import { z } from 'zod';

export const ConfirmWorkTimerOvertimeBodySchema = z.object({
  mechanicUserId: z.uuid(),
});

export type ConfirmWorkTimerOvertimeBody = z.infer<typeof ConfirmWorkTimerOvertimeBodySchema>;

export const ConfirmWorkTimerOvertimeResponseSchema = z.object({
  placeId: z.uuid(),
  mechanicUserId: z.uuid(),
  civilDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  grantedUntil: z.iso.datetime(),
});

export type ConfirmWorkTimerOvertimeResponse = z.infer<
  typeof ConfirmWorkTimerOvertimeResponseSchema
>;
